import { ChevronsUp, Minus, ChevronsDown } from 'lucide-react';

const PRIORITY_CONFIG = {
    H: { label: 'High', color: '#bf5700', Icon: ChevronsUp, showBadge: true },
    M: { label: 'Normal', color: '#1a6b3c', Icon: Minus, showBadge: false },
    L: { label: 'Low', color: '#1e40af', Icon: ChevronsDown, showBadge: false },
};

const normalize = (priority) => {
    if (!priority) return null;
    const map = { High: 'H', Normal: 'M', Low: 'L' };
    return map[priority] || (PRIORITY_CONFIG[priority] ? priority : null);
};

/**
 * PriorityBadge
 *
 * mode:
 *   "badge"  — icon + label pill (default)
 *   "icon"   — icon only
 *   "dot"    — colored circle
 *
 * showAlways — show badge even for M and L priorities
 */
const PriorityBadge = ({ priority, mode = 'badge', showAlways = false, className = '' }) => {
    const key = normalize(priority);
    if (!key) return null;

    const { label, color, Icon, showBadge } = PRIORITY_CONFIG[key];

    if (!showBadge && !showAlways) return null;

    if (mode === 'dot') {
        return (
            <span
                className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${className}`}
                style={{ backgroundColor: color }}
                title={label}
            />
        );
    }

    if (mode === 'icon') {
        return (
            <Icon
                className={`h-4 w-4 shrink-0 ${className}`}
                style={{ color }}
                title={label}
            />
        );
    }

    // badge mode
    return (
        <span
            className={`inline-flex items-center text-[12px] px-2 py-1 border rounded-md font-semibold ${className}`}
            style={{
                color,
                borderColor: color + '66',
                backgroundColor: color + '22',
            }}
        >
            <Icon className="h-3 w-3 mr-1.5 shrink-0" style={{ color }} fill={color} />
            {label}
        </span>
    );
};

export default PriorityBadge;
